<script lang="ts">
import { Component, Prop } from 'vue-property-decorator'
import BaseButtonBulk from './BaseButtonBulk.vue'

@Component({
  name: 'FinishButtonBulk',
})
export default class FinishButtonNulk extends BaseButtonBulk {
  // protected label = 'finish';
  protected color = 'is-info'
}
</script>
